<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="684px"
      :style="{ zIndex: options.zIndex }"
    >
      <v-card v-if="dialog">
        <v-card-title>
          <h2>Wie möchten Sie den neuen Prozess erstellen?</h2>
          <v-spacer />
          <v-btn icon @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-7">
          <v-container>
          <v-row style="width: 100%, height: 100%;">
          <v-col class="px-7">
          <v-card id="cardFrame" fluid class="fill-height text-center" elevation="0"  @click="sendResponse('NEW')">
            <v-card elevation="0" class="py-6 d-flex justify-center">
              <div class="svg-container mt-4">
                <svg viewBox="0 0 72 66" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1493_9208)">
                    <ellipse cx="31" cy="35.5" rx="30" ry="27.5" fill="#F1F1F1"/>
                    <path d="M33.3574 58.0952L13.6016 38.3495M33.3574 58.0952H21.5039L17.5528 62.0463L9.65044 54.144L13.6016 50.1928V38.3495M33.3574 58.0952L40.1784 49.1217M13.6016 38.3495L22.5751 31.5183M22.5751 31.5183L56.074 1.79874L69.898 15.6227L40.1784 49.1217M22.5751 31.5183L40.1784 49.1217M18.917 65.0173H71.9999M16.5624 61.0661L10.6307 55.1343L0.757812 65.0173H12.6113L16.5624 61.0661ZM69.8778 7.70022L63.9864 1.80885C62.8142 0.636638 60.9953 0.414322 59.5704 1.26316L57.0542 2.77895L68.9077 14.6324L70.4235 12.1162C71.2723 10.6914 71.05 8.87243 69.8778 7.70022Z" stroke="#B7B7B7" stroke-width="1.5" stroke-linejoin="round"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_1493_9208">
                      <rect width="72" height="65.7752" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </v-card>
              <v-card-title primary-title class="justify-center p-0">
                <h3 class="m-0">Neu erstellen</h3>
              </v-card-title>
              <v-card-subtitle class="text-left mt-5 px-7 pb-10">
                Erstelle ein Modell und erfasse basierend darauf die Process Experience.
              </v-card-subtitle>
          </v-card>
        </v-col>
        <v-col>
            <v-card id="cardFrame" fluid class="fill-height  text-center" elevation="0" @click="sendResponse('IMPORT')">
              <v-card elevation="0" class="py-6 d-flex justify-center">
                <div class="svg-container mt-4">
                  <svg viewBox="0 0 72 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1493_9216)">
                      <ellipse cx="42.3411" cy="25.8599" rx="29.3411" ry="25.8599" fill="#F1F1F1"/>
                      <path d="M67.4352 10.4136V5.57979H42.0427L37.2089 0.745972H11.8164L6.98261 5.57979H0.945312V46.6871M0.945312 46.6871H4.5657M0.945312 46.6871L9.39952 10.4136H71.0655L62.6013 46.6871H21.494M22.4687 37.2483C21.5238 36.3034 19.9921 36.3034 19.0473 37.2483L8.79281 47.5027C7.84792 48.4476 7.84792 49.9793 8.79281 50.9242C9.73769 51.8691 11.2694 51.8691 12.2143 50.9242L22.4687 40.6697C23.4136 39.7248 23.4136 38.1931 22.4687 37.2483ZM22.4687 37.2483L25.8902 33.8268M38.7108 31.2607C35.8761 34.0953 31.281 34.0953 28.4563 31.2607C25.6216 28.426 25.6216 23.8309 28.4563 21.0062C31.2909 18.1716 35.8861 18.1716 38.7108 21.0062C41.5454 23.8409 41.5454 28.436 38.7108 31.2607ZM44.4596 26.1384C44.4596 32.1479 39.588 37.0195 33.5785 37.0195C27.5691 37.0195 22.6975 32.1479 22.6975 26.1384C22.6975 20.129 27.5691 15.2574 33.5785 15.2574C39.588 15.2574 44.4596 20.129 44.4596 26.1384Z" stroke="#B7B7B7" stroke-width="1.5" stroke-miterlimit="10"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_1493_9216">
                        <rect width="72" height="52.3763" fill="white"/>
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </v-card>
                <v-card-title primary-title class="justify-center p-0">
                  <h3 class="m-0">Importieren</h3>
                </v-card-title>
                <v-card-subtitle class="text-left mt-5 px-7 pb-10">
                  Importiere ein Modell und erfasse basierend darauf die Process Experience.
                </v-card-subtitle>
            </v-card>
        </v-col>
      </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "ConfirmDlg",
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      options: {
        width: 800,
        zIndex: 400,
      }
    };
  },

  methods: {
    open() {
      this.dialog = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    sendResponse(res){
      this.resolve(res)
      this.dialog = false;
    },
    close(){
      this.reject();
      this.dialog = false;
    }
  }
};
</script>
<style scoped>
h3 {
  color: #575757;
}
.v-dialog{
  overflow-y: unset !important;
}
#cardFrame{
  border-radius: 10px;
  border: 1px solid #EFEFEF;
}
.svg-container {
  width: 5rem;
  height: 5rem;
}
</style>